import {updateAutoAdd, list} from "@/services/api/app/seat-management/backupsettings";
import {getEnableSpecialFolders} from "@/services/api/app/common/enableBackup";

const defaultState = () => ({
  loaded: false,
  autoAdd: {
    users: true,
    sites: true,
    teams: true,
    mailboxes: true,
    areEwsSpecialFoldersEnabled: true,
  },
  isEnableGroups: null,
  isPersonalImapEnabled: null,
  includeUnlicensed: {
    users: true,
    mailboxes: true,
  }
});

export default {
  namespaced: true,

  actions: {
    list({commit}) {
      commit('setLoaded', false);

      return list().then((data) => {
        if (data.autoAdd) {
          commit('setAutoAdd', data.autoAdd);
        }

        if (data.includeUnlicensed) {
          commit("setIncludeUnlicensed", data.includeUnlicensed);
        }

        if (typeof data.isEnableGroups !== "undefined") {
          commit("setIsEnableGroups", data.isEnableGroups);
        }

        if (typeof data.isPersonalImapEnabled !== "undefined") {
          commit("setIsPersonalImapEnabled", data.isPersonalImapEnabled);
        }

        if (typeof data.areEwsSpecialFoldersEnabled !== "undefined") {
          commit("setAutoAdd", {
            ...data.autoAdd,
            areEwsSpecialFoldersEnabled: data.areEwsSpecialFoldersEnabled
          });
        }
        commit('setLoaded', true);
      });
    },
    updateAutoAdd({commit}, data) {
      return updateAutoAdd(data)
        .then(({autoAdd, ...data}) => {
          commit('setAutoAdd', {...autoAdd, ...data})
        })
    },
    updateIncludeUnlicensed({commit}, data) {
      return updateAutoAdd(data)
        .then(({includeUnlicensed, ...data}) => {
          commit('setIncludeUnlicensed', {...includeUnlicensed, ...data})
        })
    },
    getEnableSpecialFolders({commit, dispatch, state}) {
      return getEnableSpecialFolders()
        .then((data) => {
          state.autoAdd = data
        })
    },

  },

  mutations: {
    setAutoAdd(state, autoAdd) {
      state.autoAdd = autoAdd
    },
    setIncludeUnlicensed(state, includeUnlicensed) {
      state.includeUnlicensed = includeUnlicensed;
    },
    setIsEnableGroups(state, isEnableGroups) {
      state.isEnableGroups = isEnableGroups;
    },
    setIsPersonalImapEnabled(state, value) {
      state.isPersonalImapEnabled = value;
    },
    setLoaded(state, value) {
      state.loaded = value;
    },
  },


  getters: {
    //seatType: usersSeat, sitesSeat, teamsSeat, mailboxSeat
    getAutoAddSettingByType: (state) => (seatType) => {
      return state.autoAdd && state.autoAdd[seatType];
    },
    getIncludeUnlicensed: (state) => (seatType) => {
      return state.includeUnlicensed && state.includeUnlicensed[seatType];
    }
  },

  state: defaultState()
}
